import { PublicLayout } from "@/layouts/PublicLayout";

export default function AboutPage() {
  return (
    <PublicLayout>
      <div className="max-w-4xl mx-auto p-6">
        <h1 className="text-3xl font-bold mb-6">Sobre Nós</h1>
        
        <div className="bg-card rounded-lg p-6 border mb-8">
          <h2 className="text-xl font-semibold mb-4">Nossa Missão</h2>
          <p className="text-muted-foreground mb-6">
            No monelab, nossa missão é capacitar indivíduos e empresas a gerenciar suas finanças
            com facilidade e confiança. Acreditamos que todos merecem ter controle total sobre sua
            saúde financeira e acesso a ferramentas que simplificam esse processo.
          </p>

          <h2 className="text-xl font-semibold mb-4">Nossa História</h2>
          <p className="text-muted-foreground mb-6">
            Fundada em 2023, o monelab surgiu da necessidade de uma solução abrangente para gestão
            financeira que fosse ao mesmo tempo poderosa e simples de usar. Nossa equipe de especialistas
            em finanças e tecnologia uniu forças para criar uma plataforma que atende às necessidades
            financeiras modernas.
          </p>
          
          <h2 className="text-xl font-semibold mb-4">Nossos Valores</h2>
          <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
            <li>Simplicidade: Acreditamos que gerenciar finanças deve ser simples e acessível a todos.</li>
            <li>Transparência: Mantemos comunicação clara e honesta com nossos usuários.</li>
            <li>Inovação: Buscamos constantemente melhorar e inovar nossa plataforma.</li>
            <li>Segurança: A proteção dos dados financeiros de nossos usuários é nossa prioridade máxima.</li>
            <li>Impacto: Trabalhamos para fazer uma diferença positiva na saúde financeira das pessoas.</li>
          </ul>
        </div>
        
        <div className="bg-card rounded-lg p-6 border">
          <h2 className="text-xl font-semibold mb-4">Nossa Equipe</h2>
          <p className="text-muted-foreground mb-6">
            Somos uma equipe diversificada de profissionais apaixonados por tecnologia e finanças, 
            dedicados a criar a melhor experiência possível para nossos usuários.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
            {/* Team members would go here in a real implementation */}
            <div className="text-center">
              <div className="w-24 h-24 rounded-full bg-muted mx-auto mb-4"></div>
              <h3 className="font-medium">João Silva</h3>
              <p className="text-sm text-muted-foreground">CEO & Fundador</p>
            </div>
            <div className="text-center">
              <div className="w-24 h-24 rounded-full bg-muted mx-auto mb-4"></div>
              <h3 className="font-medium">Maria Oliveira</h3>
              <p className="text-sm text-muted-foreground">CTO</p>
            </div>
            <div className="text-center">
              <div className="w-24 h-24 rounded-full bg-muted mx-auto mb-4"></div>
              <h3 className="font-medium">Carlos Santos</h3>
              <p className="text-sm text-muted-foreground">Diretor Financeiro</p>
            </div>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
}
